
  import { SecondNav } from '@wenjuan/business'

  export default {
    name: 'PersonalLayout',
    components: {
      SecondNav,
    },
    provide() {
      return {
        setPageTitle: this.setPageTitle,
      }
    },
    data() {
      return {
        pageTitle: '',
      }
    },
    methods: {
      goBackHandler() {
        this.$router.push('/list')
      },
      setPageTitle(title) {
        this.pageTitle = title
      },
    },
  }
